'use client';

import { Toast as ChakraToast } from '@chakra-ui/react';

// Re-export Toast components
export const Toast = ChakraToast;

// Export all Toast sub-components
export const ToastRoot = ChakraToast.Root;
export const ToastTitle = ChakraToast.Title;
export const ToastDescription = ChakraToast.Description;
export const ToastCloseTrigger = ChakraToast.CloseTrigger;
export const ToastIndicator = ChakraToast.Indicator;
export const ToastActionTrigger = ChakraToast.ActionTrigger;
